import { object } from '@calendly/form/validation'

import { formatDurationValues, getDurationInitialValues, getDurationValidationSchema } from 'components/event_type_edit'
import { isEtLocked } from 'services/event_type_locking'

import { panelLockNames, PANELS } from '../../constants'
import { mergeArraysOfObjectsByKeys } from '../../utils'
import { getAvailabilityInitialValues } from '../availability'
import { formatGroupEventValues, getGroupEventInitialValues, getGroupEventValidationSchema } from '../group_event'
import { getFormatHostListValues, getHostListInitialValues, getHostListValidationSchema } from '../hosts'
import { getLocationInitialValues } from '../location'
import {
  formatNameAndColorValues,
  getNameAndColorInitialValues,
  getNameAndColorValidationSchema
} from '../name_and_color_fields'

export const getEventDetailsPanelKeys = ({ isGroup, isMultiHost, isTeam, isMETParent }) => {
  let panelKeys

  if (isMultiHost) {
    panelKeys = [PANELS.duration, PANELS.hosts, PANELS.location, PANELS.availability]
  } else if (isTeam && isGroup) {
    panelKeys = [PANELS.duration, PANELS.hosts, PANELS.location, PANELS.availability, PANELS.groupEvent]
  } else if (isGroup) {
    panelKeys = [PANELS.duration, PANELS.location, PANELS.availability, PANELS.groupEvent, PANELS.hosts]
  } else {
    panelKeys = [PANELS.duration, PANELS.location, PANELS.availability, PANELS.hosts]
  }

  if (isMETParent) {
    panelKeys.push(PANELS.assign)
  }

  return panelKeys
}

const getGroupInitialValues = (eventType) => (eventType.isGroup ? getGroupEventInitialValues(eventType) : {})

export const getInitialValues = ({ eventType, defaultAvailabilityRules, isCreation }) => {
  const { isMETParent } = eventType

  const { memberships: hostListMemberships = [], ...hostListInitialValues } = getHostListInitialValues({
    eventType, isCreation
  })

  const { memberships: locationMemberships = [], ...locationInitialValues } = getLocationInitialValues({
    eventType, isCreation
  })

  const availabilityInitialValues = getAvailabilityInitialValues({
    eventType, defaultAvailabilityRules
  })

  const membershipsInitialValues = isMETParent ? {} : {
    memberships: mergeArraysOfObjectsByKeys([
      hostListMemberships,
      locationMemberships,
    ], 'id', 'user_id', 'organization_invitation_id')
  }

  return {
    ...getNameAndColorInitialValues(eventType),
    ...getDurationInitialValues(eventType),
    ...getGroupInitialValues(eventType),
    ...hostListInitialValues,
    ...availabilityInitialValues,
    ...locationInitialValues,
    ...membershipsInitialValues
  }
}

export const getEventTypeLocks = (eventType) => ({
  [PANELS.nameAndColor]: isEtLocked(eventType, panelLockNames[PANELS.nameAndColor]),
  [PANELS.duration]: isEtLocked(eventType, panelLockNames[PANELS.duration]),
  [PANELS.groupEvent]: isEtLocked(eventType, panelLockNames[PANELS.groupEvent]),
  [PANELS.hosts]: false
})

const getFormatGroupValues = (eventType, values) => (eventType.isGroup ? formatGroupEventValues(values) : {})

export const getFormatValuesToServerData = ({ eventType, isCreation }) => (values) => {
  const locks = (isCreation || eventType.isMETParent) ? {} : getEventTypeLocks(eventType)

  const formatHostListValues = getFormatHostListValues({ eventType, isCreation })

  return {
    ...(!locks[PANELS.nameAndColor] ? formatNameAndColorValues(values) : {}),
    ...(!locks[PANELS.duration] ? formatDurationValues(values) : {}),
    ...(!locks[PANELS.groupEvent] ? getFormatGroupValues(eventType, values) : {}),
    ...(!eventType.isMETParent ? formatHostListValues(values) : {}),
  }
}

export const getGroupValidationSchema = (eventType) => (eventType.isGroup ? getGroupEventValidationSchema(eventType) : object({}))

export const getValidationSchema = ({ eventType, isCreation }) => {
  const locks = (isCreation || eventType.isMETParent) ? {} : getEventTypeLocks(eventType)

  return object({})
    .concat(!locks[PANELS.nameAndColor] ? getNameAndColorValidationSchema() : object({}))
    .concat(!locks[PANELS.duration] ? getDurationValidationSchema() : object({}))
    .concat(!locks[PANELS.groupEvent] ? getGroupValidationSchema(eventType) : object({}))
    .concat(getHostListValidationSchema({ eventType }))
}
